import { FooterMenuItem } from './footer-menu-item';
import { Menu, MenuItemData, MenuProps } from '@cue/molecules';
import { useNavMenu } from '@project/hooks/use-nav-menu';
import { useMemo } from 'react';

export const FooterMenu = ({ slug, onCustomAction }: FooterMenuProps) => {
  const { menuItems } = useNavMenu(slug);

  const items = useMemo(
    () =>
      menuItems.map((item) => ({
        ...item,
        render: (menuProps: MenuItemData) => (
          <FooterMenuItem {...menuProps} onCustomAction={onCustomAction} />
        ),
      })),
    [menuItems, onCustomAction],
  );

  return <Menu items={items} />;
};
export interface FooterMenuProps extends Partial<MenuProps> {
  slug: string;
  onCustomAction?(custom_action: string): void;
}
